import { useApp } from "../context/AppContext";
import { tr } from "../i18n/translations";

export default function Marquee() {
  const { lang } = useApp();
  const items = [
    tr(lang, "marquee_1"),
    tr(lang, "marquee_2"),
    tr(lang, "marquee_3"),
    tr(lang, "marquee_4"),
    tr(lang, "marquee_5"),
  ];
  const loop = [...items, ...items, ...items, ...items];

  return (
    <div className="bg-ivory-200 border-y border-ink/5 overflow-hidden" data-testid="home-marquee">
      <div className="marquee-track py-4">
        {loop.map((t, i) => (
          <span key={i} className="font-display italic text-ink/70 text-base lg:text-lg whitespace-nowrap px-12 flex items-center">
            <span className="me-12 text-coral-dark">✦</span> {t}
          </span>
        ))}
      </div>
    </div>
  );
}
